import type { RouteName } from './router.js';

export const ROUTE_TITLES: Record<RouteName, string> = {
  home: 'Texas 42',
  'new-game': 'New Game — Texas 42',
  game: 'Live Game — Texas 42',
  'game-summary': 'Hand Summary — Texas 42',
  'saved-games': 'Saved Games — Texas 42',
  replay: 'Replay — Texas 42',
  'portable-replay': 'Shared Replay — Texas 42',
  stats: 'Player Stats — Texas 42',
  'how-to-play': 'How to Play — Texas 42',
  settings: 'Settings — Texas 42',
  privacy: 'Privacy — Texas 42',
  'expert-inbox': 'Expert feedback — Texas 42',
  gallery: 'Component Gallery — Texas 42',
  'not-found': 'Page Not Found — Texas 42',
};

export function titleForRoute(name: RouteName): string {
  return ROUTE_TITLES[name];
}
